export default "__VITE_ASSET__90b3053b__"